import "react-app-polyfill/stable";
// early inits
import "./errors/globalHandler";
import "./logging";
import "./auth/init.ts";
import { createRoot } from "react-dom/client";

import { createLanguageManager } from "@skilitics/nautilus-core-designer";

import * as serviceWorker from "./serviceWorker";
import { App } from "./ui";

const container = document.getElementById("root") as Element;

const root = createRoot(container);
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    root.unmount();
  });
}

const render = () => {
  root.render(<App />);
};

render();

window.interactDebug = (on: boolean) => {
  window.interactDebugMode = on;
  render();
};

window.interact = createLanguageManager();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
